// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MainWindowManager } from '../../UtilsClasses/MainWindowManager';
import { Resources } from '@shared/localizations/Resources';
import { QuickTreeNode } from '../QuickTree/QuickTreeNode';
import { TerceraLookupDropDownForm } from './TerceraLookupDropDownForm';
import { IndicatorManager } from '@shared/commons/cache/indicators/IndicatorManager';
import TerceraIndicatorLookupDropDownFormTemplate from '@front/templates/TerceraIndicatorLookupDropDownFormTemplate.html';
import { ScreensNames } from '../../UtilsClasses/FactoryConstants';
export class TerceraIndicatorLookupDropDownForm extends TerceraLookupDropDownForm {
    constructor() {
        super();
    }
    initializationComponents() {
        this.textBox = this.Controls.textBox;
        const qtr = this.Controls.quickTree;
        if (!isNullOrUndefined(qtr === null || qtr === void 0 ? void 0 : qtr.quickTree)) {
            this.quickTree = qtr;
        }
    }
    getType() {
        return ScreensNames.TerceraLookupDropDownForm;
    }
    fillTree() {
        const startNode = new QuickTreeNode();
        const filter = this.currentNameFilter;
        const procs = this.items;
        if (isValidString(filter)) {
            filter.toLowerCase();
        }
        let visibleIndicatorCount = 0;
        const len = procs.length;
        const map = {};
        for (let i = 0; i < len; i++) {
            const handler = procs[i];
            if (isValidString(filter)) {
                if (handler.ShortName.toLowerCase().indexOf(filter) === -1 &&
                    handler.FullName.toLowerCase().indexOf(filter) === -1) {
                    continue;
                }
            }
            visibleIndicatorCount++;
            let parentNode = map[handler.DisplayGroup];
            if (isNullOrUndefined(parentNode)) {
                parentNode = new QuickTreeNode();
                parentNode.nodeText = Resources.getResource('IndicatorGroup.' + handler.DisplayGroup);
                parentNode.tag = null;
                parentNode.collapsed = false;
                map[handler.DisplayGroup] = parentNode;
                startNode.AddChildNode(parentNode);
            }
            const subNode = new QuickTreeNode();
            subNode.nodeText = this.getNodeText(handler);
            subNode.tag = handler;
            parentNode.AddChildNode(subNode);
        }
        const qt = this.quickTree.quickTree;
        qt.Clear();
        qt.AddNodeRange(startNode.childNodes);
        this.quickTree.setSizes();
        this.updateVisibleIndicatorsCount(visibleIndicatorCount);
    }
    getNodeText(item) {
        var _a, _b;
        const shortName = Resources.getResource((_a = item.ShortNameLocKey) !== null && _a !== void 0 ? _a : item.ShortName);
        const fullName = Resources.getResource((_b = item.FullNameLocKey) !== null && _b !== void 0 ? _b : item.FullName);
        return `${shortName} (${fullName})`;
    }
    updateVisibleIndicatorsCount(visibleIndicatorsCount) {
        void this.set('labelCountText', isValidNumber(visibleIndicatorsCount)
            ? Resources.getResource('screen.lookup.scripts.showing').replace('{1}', visibleIndicatorsCount.toString())
            : Resources.getResource('screen.lookup.scripts.noitems'));
    }
    onAddIndicatorBtnClicked(visibleIndicatorsCount) {
        var _a;
        if (isNullOrUndefined((_a = this.quickTree) === null || _a === void 0 ? void 0 : _a.quickTree)) {
            return;
        }
        const selectedNode = this.quickTree.quickTree.selectedNode;
        if (isNullOrUndefined(selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.tag)) {
            return;
        }
        this.callBack(selectedNode.tag);
        this.close();
    }
    static PopulateWithFolderNodes(handler, curNode) {
        const folderNode = new QuickTreeNode();
        folderNode.nodeText = handler.DisplayGroup;
        folderNode.tag = true;
        curNode.AddChildNode(folderNode);
        return folderNode;
    }
    static ShowForm(params) {
        let instanceWaiter = null;
        if (isNullOrUndefined(MainWindowManager.TerceraIndicatorLookupDropDownForm)) {
            instanceWaiter = TerceraIndicatorLookupDropDownForm.createInstance().then((instance) => {
                MainWindowManager.TerceraIndicatorLookupDropDownForm = instance;
                return instance;
            });
        }
        else {
            instanceWaiter = Promise.resolve(MainWindowManager.TerceraIndicatorLookupDropDownForm);
        }
        instanceWaiter.then((instance) => {
            instance.textBox.set('text', '');
            params.isMultiSelect = false;
            params.items = IndicatorManager.GetIndicatorItemsList();
            params.isCentered = true;
            instance.showForm(params);
        });
    }
    static createInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            const lookup = new TerceraIndicatorLookupDropDownForm();
            lookup.setBounds(0, 0, 500, 550);
            void lookup.set('visible', false);
            MainWindowManager.AddControl(lookup);
            return yield lookup.OnCompliteWaiter;
        });
    }
}
TerceraLookupDropDownForm.extendWith(TerceraIndicatorLookupDropDownForm, {
    partials: { bodyPartial: TerceraIndicatorLookupDropDownFormTemplate }
});
